import React from "react";
import Button from "../ui/Button";

const ContactSection = () => {
  return (
    <section className="w-full py-[30px] 2xl:py-[80px] px-4 bg-white flex flex-col  items-center justify-center gap-8 md:gap-12 max-w-[950px] mx-auto ">
      {/* Text Container */}
      <div className="relative ">
        {/* Main Bold Text */}
        <h2 className="text-[50px] sm:text-[90px] md:text-[110px] 2xl:text-[180px] font-bold text-[#1a2e6b] leading-tight">
          Let's Work
        </h2>

        {/* Overlay Script Text */}
        <span
          className="absolute left-[20%] top-[50%] md:top-[40%] text-[#00a1b1] text-[40px] sm:text-[80px] md:text-[100px] 2xl:text-[170px]"
          style={{
            fontFamily: "Amithen", // Make sure to import this font
            transform: "rotate(-5deg)",
            zIndex: 10,
          }}
        >
          Together
        </span>
      </div>

      {/* Button Container */}
      <div className="2xl:flex 2xl:items-end 2xl:justify-end 2xl:mt-[-50px] 2xl:w-full ">
        <Button
          className="border-2 border-[#1a2e6b] text-[#1a2e6b] font-semibold rounded-full hover:bg-[#1a2e6b] hover:text-white transition-all duration-300"
          text="Contact Us"
          to="/contact"
        />
      </div>
    </section>
  );
};

export default ContactSection;
